// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1LNwS","footer":"Form_footer__26jat"};